<template>
  <div id="ag-grid-demo">
    <vx-card>
      <div class="flex justify-end items-center">
        <div class="buttons-container flex flex-wrap items-center justify-end">
          <vs-button
          v-on:click="isHidden = !isHidden"
          v-show="isHidden"
          >Add Number</vs-button>
          <vs-button
          v-show="!isHidden"
          v-on:click="isHidden = !isHidden"
          >Save</vs-button>
          <vs-button
            class="ml-3"
            @click="$router.push({ name: 'company-admin-campaign-caller-id-import' })"
          >Import Number</vs-button>
        </div>
      </div>
    </vx-card>
    <vx-card>
      <!-- Per Page -->
      <div class="flex justify-between items-center">
        <div class="mb-4 md:mb-0">
          <per-page
            :currentPerPage="per_page"
            :pageStart="pageStart"
            :pageEnd="pageEnd"
            :total="total"
            @change-per-page="ChangePerPage($event)"
          />
        </div>
        <div class="flex" v-if="!isHidden">
          <vs-input
          placeholder="Enter phone number"
          />
          <v-select
              style="min-width: 200px"
              class="ml-6 mr-3"
              name="company"
              placeholder="Campaign ID"
          />
        </div>
      </div>
      <!-- Table -->
      <ag-grid-vue
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="rowData"
        @gridReady="GridReady"
        @filterChanged="Filtering"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="isFloatingFilter"
        :pagination="true"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
        >
      </ag-grid-vue>

      <!-- Pagination -->
      <vs-pagination
        :total="totalPages"
        :max="maxPageNumbers"
        v-model="Page" />
    </vx-card>
  </div>
</template>

<script>
import TableMixin from '@/mixins/table.js'

// Packages
import { AgGridVue } from 'ag-grid-vue';
// import 'ag-grid-enterprise';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import VueApexCharts from 'vue-apexcharts'
import StatisticsCardLine from '@/views/admin/dashboard/StatisticsCardLine.vue'
import analyticsData from '@/views/admin/dashboard/analyticsData.js'
import ChangeTimeDurationDropdown from '@/views/admin/dashboard/ChangeTimeDurationDropdown.vue'
import VsInputPhone from '../../../../components/VsInputPhone.vue';
import vSelect from 'vue-select'
// import CellRendererActions from './cell-renderer/CellRendererActions'

export default {
     mixins: [TableMixin],
  components: {
    vSelect,
    AgGridVue,
    VueApexCharts,
    StatisticsCardLine,
    VuePerfectScrollbar,
    ChangeTimeDurationDropdown,
    VsInputPhone,
    // CellRendererActions
  },
  data () {
    return {
       isHidden: true,
       gridOptions: null,
       columnDefs: null,
       autoGroupColumnDef: null,
       defaultColDef: null,
       rowSelection: null,
       rowGroupPanelShow: null,
       pivotPanelShow: null,
       rowData: null,
       gridApi:null,
       maxPageNumbers:null,
    }
    // return {
    //   rowSelection: null,
    //   subscribersGained: {},
    //   revenueGenerated: {},
    //   quarterlySales: {},
    //   ordersRecevied: {},

    //   revenueComparisonLine: {},
    //   goalOverview: {},

    //   browserStatistics: [],
    //   clientRetentionBar: {},

    //   sessionsData: {},
    //   chatLog: [],
    //   chatMsgInput: '',
    //   customersData: {},

    //   analyticsData,
    //   settings: {
    //     maxScrollbarLength: 60,
    //     wheelSpeed: .60
    //   }
    // }
  },
  beforeMount() {
    this.gridOptions = {};
    this.defaultColDef = {
      editable: true,
      enableRowGroup: true,
      enablePivot: true,
      enableValue: true,
      sortable: true,
      resizable: true,
      filter: true,
      flex: 1,
      minWidth: 100,
    };
    this.rowSelection = 'multiple';
    this.rowGroupPanelShow = 'always';
    this.pivotPanelShow = 'always';
    this.rowData = [
        {
            number: 'Test1',
            vendor: 'Test1',
        },
        {
            number: 'Test2',
            vendor: 'Test2',
        },
    ],
           this.columnDefs = [
      {
        headerName: 'Number',
        field:'number',
      },
      {
        headerName: 'Vendor',
        field: 'vendor',
      },
    ]
  },
  created(){
      this.GetList()
  },
  methods: {
      GetList () {
        console.log(this.$store)
        this.$vs.loading()
        this.$store.dispatch('recipient/GetList', {
        ...this.filters,
        page: this.page || 0,
        per_page: this.per_page || 20,
        order_by: this.order_by || null,
        order_dir: this.order_dir || null,
      })
      .then(res => {
        this.list = res.items.map(this.TransformList)
        this.total = res.total
      })
      .catch(err => this.ShowErrorMessage({ title: 'Error', text: err }))
      .finally(() => this.$vs.loading.close())
      },
      SearchWithField (e, field) {
      if (!e) delete this.filters[field]
      else this.filters[field] = e && e.value

      this.GetList()
    },

    // Notify
    ShowSuccessMessage ({ title, text }) {
      this.$vs.notify({
        iconPack: 'feather',
        icon: 'icon-check',
        color: 'success',
        title,
        text
      })
    },
    ShowErrorMessage ({ title, text }) {
      this.$vs.notify({
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger',
        title,
        text
      })
    },

    // Transform functions
    TransformList(item) {
      console.log(item)
      return {
        refreshData: this.GetList,
        udf1: item.udf1,
        udf2: item.udf2,
        udf3: item.udf3,
        zip: item.zip,
        first_name: item.first_name,
        last_name: item.last_name,
        state: item.state,
        cityL: item.city,
        phone_number: item.phone_number
      }
    }
  },
}
</script>
<style>
.contact_page{
    margin-top: 60px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.contact_page_item{
    width: 90%;
}
    .header_side{
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin-bottom: 25px;
    }
    .header_side_buttons>button{
        width: 150px;
        height: 40px;
        background-color: #7367EC;
        border: none;
        color: white;
        border-radius: 7px;
        margin-right: 10px;
    }
</style>
